export const isNode = typeof process === 'object' && !!process.versions && !!process.versions.node;
